import { Injectable, inject, signal } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';

import { ChannelType, ProductType } from '../config/appConstants';
import { QDInstrument } from '../model/qdInstrument.model';
import { DataService } from './data.service';
import { QuickDepositMessageService } from './quick-deposit-message.service';

@Injectable({
    providedIn: 'root',
})
export class OptionListService {
    private dataService = inject(DataService);
    private navigationService = inject(NavigationService);
    private quickDepositMessageService = inject(QuickDepositMessageService);

    _reversalExists = false;
    _selectedOption: QDInstrument;
    _optionList: QDInstrument[];
    dataLoading = signal<boolean>(false);
    _reversalArr: any[];

    set optionList(_optionList) {
        this._optionList = _optionList;
    }

    get optionList() {
        return this._optionList;
    }

    set selectedOption(_selectedOption) {
        this._selectedOption = _selectedOption;
    }

    get selectedOption() {
        return this._selectedOption;
    }

    set reversalExists(_reversalExists) {
        this._reversalExists = _reversalExists;
    }

    get reversalExists() {
        return this._reversalExists;
    }

    set reversalArr(_reversalArr: any[]) {
        this._reversalArr = _reversalArr;
    }

    get reversalArr() {
        return this._reversalArr;
    }

    redirectToMainCashier(module: string = '&type=options') {
        const { channelId, productId } = this.dataService.sessionInfo || {};

        if (
            channelId === ChannelType.VC ||
            channelId === ChannelType.FC ||
            channelId === ChannelType.MC ||
            (productId == ProductType.CASINO && module == '&type=reverse-withdrawal')
        ) {
            this.postMessageToParent(productId, module);
        } else {
            this.quickDepositMessageService.sendOutput('action=close');
            const hostname = document.referrer ? new URL(document.referrer).hostname : `https://${window.location.hostname}`;
            if (module.includes('type=transactionStatus')) {
                // ex: payments?type=transactionStatus&txnId={txnId}
                this.navigationService.goTo(`/payments?parent=${hostname}${module}`);
            } else {
                // ex: payments/deposit, payments/optiosn, payments/reversal-withdrawal, payments/manage-bank-accounts
                module = module.replace('&type=', '/');
                this.navigationService.goTo(`/payments${module}?parent=${hostname}`);
            }
        }
    }

    postMessageToParent(productId: any, module = '') {
        let message = '';
        if (productId == ProductType.CASINO) {
            message = module == '&type=reverse-withdrawal' ? 'showReverseWithdrawal=true' : 'showAllOptions=true&parent=true';
        } else {
            message = 'showAllOptions=true';
        }
        message = `action=close&${message}`;
        this.quickDepositMessageService.sendOutput(message);
    }
}
